import React, { useRef, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/navigation';
import 'swiper/css/thumbs';
import {Autoplay, FreeMode, Navigation, Thumbs } from 'swiper/modules';
import "./ProductsGallery.css"
function ProductsGallery({images}) {
    const [thumbsSwiper, setThumbsSwiper] = useState(null);

  return (
    <div className='garellry'>
      <Swiper
        style={{
          '--swiper-navigation-color': '#fff',
          '--swiper-pagination-color': '#fff',
        }}
        spaceBetween={10}
        navigation={true}
      loop
      
        autoplay={{
            delay: 2500,
            disableOnInteraction: false,
          }}
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Autoplay,FreeMode, Navigation, Thumbs]}
        className="mySwiper2"
      >
        {images&&images.map((item,index)=>{
            
            return(
                <SwiperSlide key={index}>
                <img src={item?.image} alt="" />
              </SwiperSlide>
            )
        })}
   

      </Swiper>
      <Swiper
        onSwiper={setThumbsSwiper}
        loop={true}
        spaceBetween={10}
        slidesPerView={4}
        freeMode={true}
        watchSlidesProgress={true}
        modules={[FreeMode, Navigation, Thumbs]}
        className="mySwiper22"
      >

{images&&images.map((item,index)=>{
            
            return(
                <SwiperSlide key={index}>
                <img src={item.image} alt="" />
              </SwiperSlide>
            )
        })}
      </Swiper>
    </div>  )
}

export default ProductsGallery